import createAsyncSlice from '../utils/createAsyncSlice';

const orderDetails = createAsyncSlice({
  name: 'orderDetails',
  initialState: {
    data: [],
  },
});

export const fetchOrderDetails = orderDetails.asyncAction;
export const { resetState: resetOrderDetailsState } = orderDetails.actions;
export default orderDetails.reducer;
